<template>
  <div id="product">
    <div class="product-top">
      <div class="product-top-inner">
        <div class="product-top-inner-title">
          <h2>GPS定位终端LK208_旗舰版</h2>
          <span>支持多种网络通信&nbsp;|&nbsp;续航时间长 |&nbsp;准确定位&nbsp;|&nbsp;便于拆卸</span>
        </div>
      </div>
    </div>
    <div class="product-advantage">
      <div class="product-advantage-public">
        <h2><i></i>产品特性<i></i></h2>
        <p>定位准确，及时报告到达目的地所需距离，适用于各种物流运输</p>
      </div>
      <div class="product-advantage-list">
        <div class="product-advantage-list-icon" v-for="item in special">
          <div class="advantage-item" v-for="items in item.listL">
            <div class="advantage-l">
              <i class="iconfont" :class="items.icon"></i>
            </div>
            <div class="advantage-r">
              <h3>{{items.title}}</h3>
              <p>{{items.txt}}</p>
            </div>
          </div>
        </div>
        <div class="product-advantage-list-img">
          <img src="../../../static/images/product/product_mashine.png" alt="产品图片">
        </div>
        <div class="product-advantage-list-icon" v-for="item in special">
          <div class="advantage-item" v-for="items in item.listR">
            <div class="advantage-l">
              <i class="iconfont" :class="items.icon"></i>
            </div>
            <div class="advantage-r">
              <h3>{{items.title}}</h3>
              <p>{{items.txt}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-parameter">
      <div class="product-advantage-public">
        <h2><i></i>产品参数<i></i></h2>
        <p>防水防尘，小巧轻便，超长待机</p>
      </div>
      <ul class="product-parameter-list">
        <li v-for="item in parameter">
          <div class="product-parameter-list-l">{{item.title}}</div>
          <div class="product-parameter-list-r">{{item.txt}}</div>
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from "../global/footer"
  export default {
    name: "Product",
    data() {
      return {
        special: [{
          listL: [{
            id: 1,
            icon: "icon-dongtai",
            title: "多种通信",
            txt: "支持多种网络接入"
          }, {
            id: 2,
            icon: "icon-map",
            title: "LBS定位",
            txt: "LBS基站三角定位，更快更准确"
          }, {
            id: 3,
            icon: "icon-iconset0250",
            title: "电量显示",
            txt: "实时显示剩余电量"
          }, {
            id: 4,
            icon: "icon-eletrical",
            title: "反复充电",
            txt: "内置电池供电，节能环保"
          }],

          listR: [{
            id: 5,
            icon: "icon-quick",
            title: "续航时间长",
            txt: "内置6000毫安电池，可续航180天以上"
          }, {
            id: 6,
            icon: "icon-notice",
            title: "位置及时上报",
            txt: "上报间隔可调，及时获取距目的距离"
          }, {
            id: 7,
            icon: "icon-tool-hardware",
            title: "拆装便捷",
            txt: "采用强力魔术贴设计，满足恶劣环境拆装"
          }, {
            id: 8,
            icon: "icon-ipad",
            title: "机身轻薄",
            txt: "86g净重，20mm厚度，小巧不占空间"
          }]
        }],

        parameter: [{
          id: 1,
          title: "外壳材料",
          txt: "高强度ABS塑料"
        }, {
          id: 2,
          title: "通信制式",
          txt: "支持多种网络通信"
        }, {
          id: 3,
          title: "外形尺寸",
          txt: "105*60*20mm"
        }, {
          id: 4,
          title: "通信频段",
          txt: "GSM/GPRS 850/900/1800/1900MHz"
        }, {
          id: 5,
          title: "产品净重",
          txt: "86g"
        }, {
          id: 6,
          title: "供电方式",
          txt: "内置6000mAh  聚合物钴酸锂电池"
        }, {
          id: 7,
          title: "正常工作温度",
          txt: "-25X ~ +65°C"
        }, {
          id: 8,
          title: "续航能力",
          txt: "3600次上报"
        }, {
          id: 9,
          title: "定位方式",
          txt: "LBS基站三角定位"
        }, {
          id: 10,
          title: "防护等级",
          txt: "IP67 等级防尘、防水"
        }, {
          id: 11,
          title: "工蚀流",
          txt: "35~60mA @3V"
        }, {
          id: 12,
          title: "待机电流",
          txt: "小于2uA"
        }, {
          id: 13,
          title: "安装",
          txt: "强力魔术贴"
        }, {
          id: 14,
          title: "上报间隔范围",
          txt: "5分钟至24小时，上报间隔可调"
        }, {
          id: 15,
          title: "开关机",
          txt: "拨动开关"
        }, {
          id: 16,
          title: "指示灯",
          txt: "绿灯闪上线定位"
        }, {
          id: 17,
          title: "认证证书",
          txt: "3C、FCC、CE等"
        }, {
          id: 18,
          title: "优势特点",
          txt: "可重复使用、可充电"
        }, {
          id: 19,
          title: "激活",
          txt: "开机上线即用"
        }, {
          id: 20,
          title: "续航时间",
          txt: "2小时报一次，可续航180天以上"
        }]
      }
    },
    components: {
      Footer
    }
  }
</script>

<style>
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }
</style>

<style scoped>
  @import "./pro/product.css";
  @import "../../../static/font/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/product/product.vue